import type { ReactNode } from 'react';
import { WIZARD_STEPS } from './avatarTypes';

interface StepWizardProps {
  currentStep: number;
  completedSteps: Set<number>;
  onStepClick: (index: number) => void;
  onBack: () => void;
  onNext: () => void;
  children: ReactNode;
}

export default function StepWizard({
  currentStep,
  completedSteps,
  onStepClick,
  onBack,
  onNext,
  children,
}: StepWizardProps) {
  const step = WIZARD_STEPS[currentStep];
  const isFirst = currentStep === 0;
  const isLast = currentStep === WIZARD_STEPS.length - 1;

  return (
    <div className="malpedia-avatar-wizard">
      {/* Progress Bar */}
      <div className="malpedia-avatar-steps" role="tablist">
        {WIZARD_STEPS.map((s, i) => {
          const done = completedSteps.has(i);
          const active = i === currentStep;
          let cls = 'malpedia-avatar-step';
          if (done) cls += ' malpedia-avatar-step--done';
          if (active) cls += ' malpedia-avatar-step--active';
          return (
            <button
              key={s.key}
              className={cls}
              role="tab"
              aria-selected={active}
              onClick={() => onStepClick(i)}
            >
              <span className="malpedia-avatar-step-indicator">
                {done && !active ? '\u2713' : i + 1}
              </span>
              <span className="malpedia-avatar-step-label">{s.label}</span>
            </button>
          );
        })}
      </div>

      {/* Drawer */}
      <div className="malpedia-avatar-drawer">
        <div className="malpedia-avatar-drawer-header">
          <div>
            <div className="malpedia-avatar-drawer-title">
              Step {currentStep + 1}: {step.label}
            </div>
            <div className="malpedia-avatar-drawer-desc">{step.description}</div>
          </div>
          <div className="malpedia-avatar-drawer-nav">
            <button
              className="malpedia-avatar-btn malpedia-avatar-btn--secondary"
              onClick={onBack}
              disabled={isFirst}
            >
              ← Back
            </button>
            <button
              className="malpedia-avatar-btn malpedia-avatar-btn--secondary"
              onClick={onNext}
              disabled={isLast}
            >
              Next →
            </button>
          </div>
        </div>
        <div className="malpedia-avatar-drawer-content">
          {children}
        </div>
      </div>
    </div>
  );
}
